import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import OmitType from "customTypes/OmitType";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import clsx from "clsx";
import { fonts } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            "& .MuiOutlinedInput-root:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline": {
                border: `2px solid ${theme.palette.secondary.main}`,
            },
            "& .MuiInputBase-root": {
                backgroundColor: theme.palette.background.paper,
                fontFamily: fonts.primary,
                textTransform: "uppercase",
                borderRadius: 0,
                fontSize: "1.5rem",
            },
            "& .MuiInputBase-input": {
                padding: "5px 10px",
            },
        },
    });
});

interface IProps extends OmitType<TextFieldProps, "variant"> {}

export default function StyledTextField(props: IProps) {
    const { className = "", ...rest } = props;
    const classes = useStyles();

    return (
        <TextField
            variant="outlined"
            color="primary"
            className={clsx(className, classes.root)}
            {...rest}
        />
    );
}
